"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagSchema = exports.TagIdentifierSchema = void 0;
const zod_1 = require("zod");
exports.TagIdentifierSchema = zod_1.z.object({
    id: zod_1.z.string(),
    name: zod_1.z.string(),
});
exports.TagSchema = exports.TagIdentifierSchema.extend({
    createdAt: zod_1.z.coerce.date(),
    updatedAt: zod_1.z.coerce.date(),
});
//# sourceMappingURL=tag.js.map